import { React, useState, useRef } from "react";
import ContactPopup from "../ContactPopup";
import { Helmet } from "react-helmet";
// import "./ServicePage.css";
import "../ImportExport/ServicePages.css";
const DesignRegistration = () => {
const [openPopup, setOpenPopup] = useState(false);

    const contactRef = useRef(null);

    const scrollToContact = () => {
        contactRef.current?.scrollIntoView({ behavior: "smooth" });
    }

  return (
    <div className="service-page">

      <Helmet>
        <title>
          Design Registration Service in India | Industrial Design Protection
        </title>

        <meta
          name="description"
          content="Get Design Registration in India to protect the visual appearance, shape, pattern, and packaging design of your products. Fast and hassle-free design registration assistance."
        />

        <meta
          name="keywords"
          content="Design Registration, Industrial Design Registration, Product Design Protection, Design Patent India, Packaging Design Registration"
        />
      </Helmet>

      {/* HERO */}
      <section className="service-hero">
        <h1>Design Registration Service</h1>
        <p>
          Protect Your Product Design, Shape & Appearance Legally
        </p>
        <button className="hero-btn" onClick={scrollToContact}>
                        Get Started Today
                    </button>
      </section>

      {/* OVERVIEW */}
      <section className="service-section">
        <h2>Overview</h2>

        <div className="service-card">
          <p>
            Design Registration protects the visual appearance, shape,
            configuration, pattern, or ornamentation of a product under the
            Designs Act, 2000.
          </p>

          <p>
            It helps businesses prevent unauthorized copying of product designs
            and provides exclusive legal rights over the registered design.
          </p>
        </div>
      </section>

      {/* WHAT CAN BE REGISTERED */}
      <section className="service-section">
        <h2>What Can Be Protected?</h2>

        <div className="service-grid-box">
          <div className="service-card">Product Shape</div>
          <div className="service-card">Packaging Design</div>
          <div className="service-card">Pattern & Ornamentation</div>
          <div className="service-card">Industrial Product Design</div>
          <div className="service-card">Fashion Accessories</div>
          <div className="service-card">Furniture Design</div>
        </div>
      </section>

      {/* BENEFITS */}
      <section className="service-section">
        <h2>Benefits of Design Registration</h2>

        <div className="service-grid-box">
          <div className="service-card">
            ✔ Exclusive ownership of design
          </div>

          <div className="service-card">
            ✔ Protection from copying & imitation
          </div>

          <div className="service-card">
            ✔ Enhances brand value
          </div>

          <div className="service-card">
            ✔ Legal rights against infringement
          </div>

          <div className="service-card">
            ✔ Competitive business advantage
          </div>

          <div className="service-card">
            ✔ Builds product uniqueness
          </div>
        </div>
      </section>

      {/* WHO SHOULD APPLY */}
      <section className="service-section">
        <h2>Who Should Apply?</h2>

        <div className="service-grid-box">
          <div className="service-card">Manufacturers</div>
          <div className="service-card">Product Designers</div>
          <div className="service-card">Furniture Businesses</div>
          <div className="service-card">Packaging Companies</div>
          <div className="service-card">Fashion Brands</div>
          <div className="service-card">Industrial Businesses</div>
        </div>
      </section>

      {/* DOCUMENTS */}
      <section className="service-section">
        <h2>Documents Required</h2>

        <div className="service-grid-box">
          <div className="service-card">PAN & Aadhaar</div>
          <div className="service-card">Design Images/Drawings</div>
          <div className="service-card">Business Registration Proof</div>
          <div className="service-card">Applicant Details</div>
          <div className="service-card">Description of Design</div>
          <div className="service-card">Power of Attorney</div>
        </div>
      </section>

      {/* PROCESS */}
      <section className="service-section">
        <h2>Design Registration Process</h2>

        <div className="service-grid-box">
          <div className="service-card">
            Design Evaluation
          </div>

          <div className="service-card">
            Documentation Preparation
          </div>

          <div className="service-card">
            Application Filing
          </div>

          <div className="service-card">
            Examination by Authority
          </div>

          <div className="service-card">
            Objection Handling (if any)
          </div>

          <div className="service-card">
            Registration Certificate
          </div>
        </div>
      </section>

      {/* OUR SERVICES */}
      <section className="service-section">
        <h2>Our Services Include</h2>

        <div className="service-card">
          <ul>
            <li>Design search & consultation</li>
            <li>Application drafting & filing</li>
            <li>Documentation assistance</li>
            <li>Design classification support</li>
            <li>Government response handling</li>
            <li>Complete end-to-end assistance</li>
          </ul>
        </div>
      </section>

      {/* WHY CHOOSE US */}
      <section className="service-section">
        <h2>Why Choose Us?</h2>

        <div className="service-card">
          <ul>
            <li>✔ Experienced IPR professionals</li>
            <li>✔ Fast & accurate filing</li>
            <li>✔ Affordable pricing</li>
            <li>✔ Complete documentation support</li>
            <li>✔ Dedicated expert assistance</li>
          </ul>
        </div>
      </section>

      {/* CTA */}
      {/* <section className="service-cta">
        <h2>Protect Your Product Design Today</h2>

        <p>
          Secure your unique product appearance with professional design
          registration services.
        </p>

        <button>Apply Now</button>
      </section> */}

         <div className="cta" ref={contactRef}>
              <h2>Protect Your Product Design Today</h2>
              <p> Secure your unique product appearance with professional design
          registration services.</p>
      
              <div className="cta-buttons">
                <button onClick={() => setOpenPopup(true)}>Apply Now</button>
                <ContactPopup
                  isOpen={openPopup}
                  onClose={() => setOpenPopup(false)}
                />
      
                <button className="outline" onClick={() => window.location.href = "tel:9218103915"} >Free Consultation</button>
              </div>
            </div>

    </div>
  );
};

export default DesignRegistration;